import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';

// project-imports
import ComponentsRoutes from './ComponentsRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import EvaluacionTercerosRoutes from './EvaluacionTercerosRoutes';

import { APP_DEFAULT_PATH } from 'config';
import { useBuyNowLink } from 'hooks/buyNowLink';
import useAuth from 'hooks/useAuth';

// ==============================|| ROUTES RENDER ||============================== //

function RootRedirect() {
  const { isLoggedIn, isLoading } = useAuth();
  const { getQueryParams } = useBuyNowLink();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (isLoggedIn) {
    return <Navigate to={APP_DEFAULT_PATH + getQueryParams} replace />;
  }

  return <Navigate to="/login" state={{ from: location.pathname }} replace />;
}

const basename = import.meta.env.VITE_APP_BASE_NAME;

const router = createBrowserRouter(
  [
    {
      path: '/react/*',
      element: <Navigate to="/" replace />
    },
    {
      path: '/',
      element: <RootRedirect />
    },
    LoginRoutes,
    ComponentsRoutes,
    EvaluacionTercerosRoutes,
    MainRoutes
  ],
  { basename: basename && basename !== '/' ? basename : undefined }
);

export default router;
